import { http } from "@/lib/api";

export const VIDEO_URL = /https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch|shorts\/|live\/|embed\/)|youtu\.be\/|vimeo\.com\/|player\.vimeo\.com\/|dailymotion\.com\/video\/|dai\.ly\/|ted\.com\/talks\/|twitch\.tv\/videos\/|(?:vm\.)?tiktok\.com\/|instagram\.com\/(?:reel|p|tv)\/|facebook\.com\/(?:watch|reel|[^/\s]+\/videos)|fb\.watch\/|(?:x|twitter)\.com\/[^/\s]+\/status\/|loom\.com\/share\/|[\w-]*\.?zoom\.us\/rec\/|coursera\.org\/|udemy\.com\/|khanacademy\.org\/|drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?)|dropbox\.com\/|1drv\.ms\/|onedrive\.live\.com\/|[\w-]+\.sharepoint\.com\/|\S+\.(?:mp4|mov|webm|mkv|avi|m4v)(?:\?\S*)?(?=\s|$))\S*/i;
export const VIDEO_ACCEPT = ".mp4,.mov,.webm,.mkv,.avi,.m4v,video/*";

export const fmtDuration = (s) => {
  const t = Math.round(s || 0);
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), sec = t % 60;
  return h ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}` : `${m}:${String(sec).padStart(2, "0")}`;
};

export const tsToSeconds = (ts) => ts.split(":").reduce((a, v) => a * 60 + Number(v), 0);

export async function uploadVideo(file, onProgress) {
  const { data: init } = await http.post("/videos/uploads", { filename: file.name, size: file.size });
  let offset = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + init.chunk_size);
    try {
      const { data } = await http.put(`/videos/uploads/${init.upload_id}`, chunk, {
        params: { offset }, headers: { "Content-Type": "application/octet-stream" },
      });
      offset = data.received;
    } catch (e) {
      const expected = e.response?.data?.detail?.expected;
      if (e.response?.status !== 409 || expected === undefined) throw e;
      offset = expected;
    }
    onProgress(Math.round((100 * offset) / file.size));
  }
  const { data } = await http.post(`/videos/uploads/${init.upload_id}/finish`);
  return data;
}
